import 'novella-agri/src/scss/show-news/news-image-slider.scss';

export default class NewsImageSlider {
  constructor(args) {
    this.element = document.querySelector('.news-images .glide');

    if (!this.element) return;

    this.slides = [...this.element.querySelectorAll('.glide__slide')];
    this.bullets = [...document.querySelectorAll('.news-images .glide .glide__bullet')];

    if (this.slides.length <= 1) return;

    this.activeClass = 'active';
    this.enabledClass = 'enabled';

    this.slider = new Glide(this.element, {
      type: 'carousel',
      perMove: 1,
      perView: 1,
      bound: 0,
      gap: 0,
      autoplay: 10000
    }).mount();

    this.addEvents();
    this.slider.mount();
  }

  addEvents() {
    this.slider.on('mount.after', _ => this.element.classList.add(this.enabledClass));
    this.slider.on('run.before', _ => this.bullets[this.slider.index].classList.remove(this.activeClass));
    this.slider.on('run', _ => this.bullets[this.slider.index].classList.add(this.activeClass));
    this.slider.on('move.after', _ => bLazy.revalidate());

    this.bullets.map(bullet => {
      bullet.addEventListener('click', e => {
        this.slider.go(e.target.getAttribute('data-glide-dir'));
      });
    });
  }
}